import { createSelector } from 'reselect';
import { initialState } from './reducer';
var careerDomain = function (state) { return state.career || initialState; };
export var selectCareerDomain = createSelector(careerDomain, function (domain) { return domain; });
export var selectCareerSource = createSelector(careerDomain, function (domain) { return ({
    sourceNode: domain.sourceNode,
    sourcePatch: domain === null || domain === void 0 ? void 0 : domain.sourcePatch,
    sourcePort: domain.sourcePort,
    position: domain.position,
    edge: domain.edge,
}); });
